import { motion } from 'framer-motion';
import { pageVariants, pageTransitionConfig, pageExitConfig } from './motionVariants';

const PageTransition = ({ children }) => {
    return (
        <motion.div
            variants={pageVariants}
            initial="initial"
            animate="animate"
            exit="exit"
            transition={pageTransitionConfig}
            style={{ width: '100%' }}
        >
            {children}
        </motion.div>
    );
};

export { pageVariants, pageTransitionConfig, pageExitConfig };
export default PageTransition;
